import React, { useState } from "react";
import { Box } from "grommet";
import { signIn } from "next-auth/react";
import Button from "./Button";
import GoogleIcon from "./GoogleIcon";

/**
 * GoogleSignInButton - Button to initiate Google OAuth authentication via NextAuth
 * Used on the signin page and invitation accept page
 *
 * @param {string} invitationToken - Optional invitation token for new user signup
 * @param {string} callbackUrl - URL to redirect to after successful login
 * @param {string} label - Custom button label
 */
const GoogleSignInButton = ({
    invitationToken,
    callbackUrl = "/",
    label = "Sign in with Google"
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async () => {
        setIsLoading(true);

        // Store invitation token in a cookie for the OAuth callback to use
        if (invitationToken && typeof document !== 'undefined') {
            // Set cookie that expires in 10 minutes (enough time for OAuth flow)
            document.cookie = `oauth_invitation_token=${invitationToken}; path=/; max-age=600; SameSite=Lax`;
        }

        // Use NextAuth's signIn with Google provider
        await signIn('google', {
            callbackUrl,
        });

        // Note: signIn will redirect, so this won't execute unless there's an error
        setIsLoading(false);
    };

    return (
        <Box>
            <Button
                secondary
                label={isLoading ? "Signing in..." : label}
                onClick={handleClick}
                disabled={isLoading}
                icon={<GoogleIcon size={18} />}
                event={{ section: 'sign_in_form', element: 'google_login' }}
            />
        </Box>
    );
};

export default GoogleSignInButton;
